(function(){
  function wire(scroller, host, count){
    if(scroller.__ccDots||count<2) return; scroller.__ccDots=1;
    var dots=document.createElement('span'); dots.className='cc-dots'; dots.setAttribute('aria-hidden','true');
    for(var i=0;i<count;i++) dots.appendChild(document.createElement('i'));
    host.appendChild(dots);
    var raf=0;
    function upd(){raf=0; var w=scroller.clientWidth||1; var k=Math.round(scroller.scrollLeft/w); [].forEach.call(dots.children,function(d,n){d.classList.toggle('on',n===k)})}
    scroller.addEventListener('scroll',function(){if(!raf) raf=requestAnimationFrame(upd)},{passive:true}); upd();
  }
  function init(root){
    root.querySelectorAll('[data-swipe]').forEach(function(s){wire(s,s.parentElement,s.children.length)});
    root.querySelectorAll('product-card slideshow-slides').forEach(function(s){
      var host=s.closest('.card-gallery'); if(!host) return;
      var n=s.querySelectorAll(':scope > slideshow-slide').length; wire(s,host,n);
    });
  }
  if(document.readyState!=='loading') init(document); else document.addEventListener('DOMContentLoaded',function(){init(document)});
  if(window.ccOnDomChange) window.ccOnDomChange(function(){init(document)}, 80);
})();

/* Quick-add modal (the "+" on a card): the native modal skips vendor name,
   the discount %, and a size chart link — enrich it from the card's own
   already-rendered cc-card data, and fetch the size chart image on demand. */
(function(){
  function findSourceCard(title){
    var cards = document.querySelectorAll('.cc-card');
    for (var i=0;i<cards.length;i++){
      var t = cards[i].querySelector('.cc-card__t');
      if (t && t.textContent.trim() === title.trim()) return cards[i];
    }
    return null;
  }

  function enrich(modalContent){
    if (!modalContent) return;
    var titleLink = modalContent.querySelector('.product-header a, a.product-title, [class*="product-title"]');
    var titleText = (titleLink && titleLink.textContent.trim()) ||
      (modalContent.querySelector('h1, .product-header a')||{}).textContent;
    if (!titleText) return;
    // modalContent is the same DOM node reused for every product open — only its children
    // get swapped out — so guard per-product (re-run when the title changes), not once-ever.
    if (modalContent.__ccEnrichedFor === titleText) return;
    var card = findSourceCard(titleText);
    if (!card) return;
    modalContent.__ccEnrichedFor = titleText;

    var vendorText = card.querySelector('.cc-card__v');
    var offText = card.querySelector('.cc-card__off');
    var priceHost = modalContent.querySelector('product-price, .price, [class*="price"]');

    if (vendorText && priceHost){
      var head = priceHost.closest('.product-header') || priceHost.parentElement;
      if (head && !head.querySelector('.cc-qa__vendor')){
        var v = document.createElement('p');
        v.className = 'cc-card__v cc-qa__vendor';
        v.textContent = vendorText.textContent;
        head.insertBefore(v, head.firstChild);
      }
    }
    if (offText && priceHost && !priceHost.querySelector('.cc-qa__off')){
      var o = document.createElement('i');
      o.className = 'cc-card__off cc-qa__off';
      o.textContent = offText.textContent;
      o.style.marginLeft = '6px';
      priceHost.appendChild(o);
    }

    // Size chart: fetch the product page once and reuse its size-chart image
    var productUrl = card.querySelector('.cc-card__meta')?.getAttribute('href');
    if (productUrl && !modalContent.querySelector('.cc-qa__sizechart')){
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cc-qa__sizechart';
      btn.textContent = 'Size chart';
      btn.style.cssText = 'background:none;border:0;text-decoration:underline;font:500 12px/1 var(--font-body--family);cursor:pointer;padding:0';
      btn.addEventListener('click', function(){
        if (btn.dataset.img){ openLightbox(btn.dataset.img); return; }
        btn.textContent = 'Loading…';
        fetch(productUrl).then(function(r){return r.text()}).then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var img = doc.querySelector('.cc-sc__dlg img');
          btn.textContent = 'Size chart';
          if (img){ btn.dataset.img = img.getAttribute('src'); openLightbox(btn.dataset.img); }
          else { btn.remove(); }
        }).catch(function(){ btn.textContent = 'Size chart'; });
      });
      if (priceHost) priceHost.appendChild(btn);
    }
  }

  function openLightbox(src){
    var box = document.getElementById('cc-qa-lightbox');
    if (!box){
      box = document.createElement('dialog');
      box.id = 'cc-qa-lightbox';
      box.style.cssText = 'border:0;padding:0;max-width:92vw;max-height:92vh;background:#fff';
      box.innerHTML = '<button type="button" aria-label="Close" style="position:absolute;top:8px;right:8px;background:#fff;border:1px solid #ddd;width:32px;height:32px;font-size:18px;cursor:pointer">×</button><img style="display:block;max-width:92vw;max-height:88vh" />';
      box.querySelector('button').addEventListener('click', function(){ box.close() });
      box.addEventListener('click', function(e){ if (e.target === box) box.close() });
      document.body.appendChild(box);
    }
    box.querySelector('img').src = src;
    if (box.showModal) box.showModal();
  }

  new MutationObserver(function(){
    var modalContent = document.getElementById('quick-add-modal-content');
    if (modalContent) enrich(modalContent);
  }).observe(document.body, {childList:true, subtree:true});
})();
